
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 57.735","preserveAspectRatio":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Cart Icon","d":"M13.333 22a2 2 0 11-2-2 2 2 0 012 2zM18 20a2 2 0 102 2 2 2 0 00-2-2zM3.916 13.333L0 4h22.416l-2.636 9.333H3.916zm14.977-6.666H4.011l1.678 4h12.075zM26.407 0l-4.576 16h-16.8l1.118 2.667h17.652l4.632-16h2.572L32 0h-5.593z","fill":"red","fill-rule":"evenodd"}})])
          )
        }
      }
    